var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasAnyData
    ? _c("div", { staticClass: "reporting-section" }, [
        _c("div", { staticClass: "section-header" }, [
          _c("i", { staticClass: "material-icons section-icon" }, [
            _vm._v("people"),
          ]),
          _c("h2", [_vm._v(_vm._s(_vm.sectionTitle))]),
        ]),
        _vm.personaSummary
          ? _c("div", { staticClass: "persona-block" }, [
              _c("div", { staticClass: "block-title" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "dash.reporting.section.demographie.subtitle.profil_type"
                    )
                  )
                ),
              ]),
              _c("div", { staticClass: "persona-chips" }, [
                _vm.personaSummary.gender
                  ? _c("div", { staticClass: "persona-chip" }, [
                      _c(
                        "div",
                        {
                          staticClass: "chip-icon gender-icon",
                          style: { background: _vm.personaSummary.gender.bg },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "gender-symbol",
                              style: {
                                color: _vm.personaSummary.gender.iconColor,
                              },
                            },
                            [_vm._v(_vm._s(_vm.personaSummary.gender.icon))]
                          ),
                        ]
                      ),
                      _c("div", { staticClass: "chip-body" }, [
                        _c("span", { staticClass: "chip-label" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("dash.reporting.section.demographie.genre")
                            )
                          ),
                        ]),
                        _c("span", { staticClass: "chip-value" }, [
                          _vm._v(_vm._s(_vm.personaSummary.gender.name)),
                        ]),
                        _c("span", { staticClass: "chip-pct" }, [
                          _vm._v(_vm._s(_vm.personaSummary.gender.pct) + "%"),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
                _vm.personaSummary.age
                  ? _c("div", { staticClass: "persona-chip" }, [
                      _vm._m(0),
                      _c("div", { staticClass: "chip-body" }, [
                        _c("span", { staticClass: "chip-label" }, [
                          _vm._v("Âge"),
                        ]),
                        _c("span", { staticClass: "chip-value" }, [
                          _vm._v(_vm._s(_vm.personaSummary.age.name)),
                        ]),
                        _c("span", { staticClass: "chip-pct" }, [
                          _vm._v(_vm._s(_vm.personaSummary.age.pct) + "%"),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
                _vm.personaSummary.country
                  ? _c("div", { staticClass: "persona-chip" }, [
                      _c("div", { staticClass: "chip-icon country-icon" }, [
                        _vm.personaSummary.country.code
                          ? _c("img", {
                              staticClass: "country-flag-img",
                              attrs: {
                                src: `https://flagcdn.com/h40/${_vm.personaSummary.country.code.toLowerCase()}.png`,
                                alt: "",
                              },
                            })
                          : _c(
                              "i",
                              {
                                staticClass: "material-icons",
                                staticStyle: {
                                  color: "#10B981",
                                  "font-size": "20px",
                                },
                              },
                              [_vm._v("place")]
                            ),
                      ]),
                      _c("div", { staticClass: "chip-body" }, [
                        _c("span", { staticClass: "chip-label" }, [
                          _vm._v(
                            _vm._s(_vm.$t("dash.reporting.top_countries"))
                          ),
                        ]),
                        _c("span", { staticClass: "chip-value" }, [
                          _vm._v(_vm._s(_vm.personaSummary.country.name)),
                        ]),
                        _c("span", { staticClass: "chip-pct" }, [
                          _vm._v(_vm._s(_vm.personaSummary.country.pct) + "%"),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
              ]),
            ])
          : _vm._e(),
        _vm.personaGenderData.length
          ? _c("div", { staticClass: "demo-block" }, [
              _c("div", { staticClass: "block-title" }, [
                _vm._v(
                  _vm._s(_vm.$t("dash.reporting.section.demographie.genre"))
                ),
              ]),
              _c(
                "div",
                { staticClass: "gender-list" },
                _vm._l(_vm.personaGenderData, function (g) {
                  return _c("div", { key: g.key, staticClass: "gender-item" }, [
                    _c("span", { staticClass: "gender-label" }, [
                      _vm._v(_vm._s(g.name)),
                    ]),
                    _c("div", { staticClass: "gender-bar-wrap" }, [
                      _c("div", {
                        staticClass: "gender-bar",
                        style: { width: g.pct + "%", background: g.color },
                      }),
                    ]),
                    _c("span", { staticClass: "gender-pct" }, [
                      _vm._v(_vm._s(g.pct) + "%"),
                    ]),
                  ])
                }),
                0
              ),
            ])
          : _vm._e(),
        _vm.personaAgeData.length
          ? _c("div", { staticClass: "demo-block" }, [
              _c("div", { staticClass: "block-title" }, [_vm._v("Âge")]),
              _c(
                "div",
                { staticClass: "country-list" },
                [
                  _vm._l(_vm.personaAgeData, function (item, idx) {
                    return [
                      _c(
                        "span",
                        { key: "ar-" + idx, staticClass: "country-rank" },
                        [_vm._v(_vm._s(idx + 1))]
                      ),
                      _c(
                        "span",
                        { key: "an-" + idx, staticClass: "country-name" },
                        [_vm._v(_vm._s(item.name))]
                      ),
                      _c(
                        "div",
                        { key: "ab-" + idx, staticClass: "country-bar-wrap" },
                        [
                          _c("div", {
                            staticClass: "country-bar age-bar",
                            style: { width: item.barWidth + "%" },
                          }),
                        ]
                      ),
                      _c(
                        "span",
                        { key: "ap-" + idx, staticClass: "country-pct" },
                        [_vm._v(_vm._s(item.pct) + "%")]
                      ),
                    ]
                  }),
                ],
                2
              ),
            ])
          : _vm._e(),
        _vm.topCountries.length
          ? _c("div", { staticClass: "demo-block" }, [
              _c("div", { staticClass: "block-title" }, [
                _vm._v(_vm._s(_vm.$t("dash.reporting.top_countries"))),
              ]),
              _vm.countryMapData
                ? _c(
                    "div",
                    { staticClass: "map-wrap" },
                    [
                      _c("MapChart", {
                        attrs: {
                          countryData: _vm.countryMapData,
                          LangUser: _vm.mapLang,
                          "currency-add": false,
                          highColor: "rgba(107, 31, 77, 1)",
                          lowColor: "rgba(107, 31, 77, 0.08)",
                          countryStrokeColor: "#ffffff",
                          defaultCountryFillColor: "#e8e4ec",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "country-list" },
                [
                  _vm._l(_vm.topCountries, function (item, idx) {
                    return [
                      _c(
                        "span",
                        { key: "rank-" + idx, staticClass: "country-rank" },
                        [_vm._v(_vm._s(idx + 1))]
                      ),
                      _c(
                        "span",
                        { key: "name-" + idx, staticClass: "country-name" },
                        [_vm._v(_vm._s(item.name))]
                      ),
                      _c(
                        "div",
                        { key: "bar-" + idx, staticClass: "country-bar-wrap" },
                        [
                          _c("div", {
                            staticClass: "country-bar",
                            style: { width: item.barWidth + "%" },
                          }),
                        ]
                      ),
                      _c(
                        "span",
                        { key: "pct-" + idx, staticClass: "country-pct" },
                        [_vm._v(_vm._s(item.pct) + "%")]
                      ),
                    ]
                  }),
                ],
                2
              ),
            ])
          : _vm._e(),
        _vm.topCities.length
          ? _c("div", { staticClass: "demo-block" }, [
              _c("div", { staticClass: "block-title" }, [_vm._v("Top villes")]),
              _c(
                "div",
                { staticClass: "country-list" },
                [
                  _vm._l(_vm.topCities, function (item, idx) {
                    return [
                      _c(
                        "span",
                        { key: "rank-" + idx, staticClass: "country-rank" },
                        [_vm._v(_vm._s(idx + 1))]
                      ),
                      _c(
                        "span",
                        { key: "name-" + idx, staticClass: "country-name" },
                        [_vm._v(_vm._s(item.name))]
                      ),
                      _c(
                        "div",
                        { key: "bar-" + idx, staticClass: "country-bar-wrap" },
                        [
                          _c("div", {
                            staticClass: "country-bar",
                            style: { width: item.barWidth + "%" },
                          }),
                        ]
                      ),
                      _c(
                        "span",
                        { key: "pct-" + idx, staticClass: "country-pct" },
                        [_vm._v(_vm._s(item.pct) + "%")]
                      ),
                    ]
                  }),
                ],
                2
              ),
            ])
          : _vm._e(),
        _vm.topIndustries.length
          ? _c("div", { staticClass: "demo-block" }, [
              _c("div", { staticClass: "block-title" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("dash.reporting.section.demographie.industries")
                  )
                ),
              ]),
              _c(
                "div",
                { staticClass: "country-list" },
                [
                  _vm._l(_vm.topIndustries, function (item, idx) {
                    return [
                      _c(
                        "span",
                        { key: "rank-" + idx, staticClass: "country-rank" },
                        [_vm._v(_vm._s(idx + 1))]
                      ),
                      _c(
                        "span",
                        { key: "name-" + idx, staticClass: "country-name" },
                        [_vm._v(_vm._s(item.name))]
                      ),
                      _c(
                        "div",
                        { key: "bar-" + idx, staticClass: "country-bar-wrap" },
                        [
                          _c("div", {
                            staticClass: "country-bar li-bar",
                            style: { width: item.barWidth + "%" },
                          }),
                        ]
                      ),
                      _c(
                        "span",
                        { key: "pct-" + idx, staticClass: "country-pct" },
                        [_vm._v(_vm._s(item.pct) + "%")]
                      ),
                    ]
                  }),
                ],
                2
              ),
            ])
          : _vm._e(),
        _vm.topSeniority.length
          ? _c("div", { staticClass: "demo-block" }, [
              _c("div", { staticClass: "block-title" }, [
                _vm._v(
                  _vm._s(_vm.$t("dash.reporting.section.demographie.seniority"))
                ),
              ]),
              _c(
                "div",
                { staticClass: "country-list" },
                [
                  _vm._l(_vm.topSeniority, function (item, idx) {
                    return [
                      _c(
                        "span",
                        { key: "rank-" + idx, staticClass: "country-rank" },
                        [_vm._v(_vm._s(idx + 1))]
                      ),
                      _c(
                        "span",
                        { key: "name-" + idx, staticClass: "country-name" },
                        [_vm._v(_vm._s(item.name))]
                      ),
                      _c(
                        "div",
                        { key: "bar-" + idx, staticClass: "country-bar-wrap" },
                        [
                          _c("div", {
                            staticClass: "country-bar li-seniority-bar",
                            style: { width: item.barWidth + "%" },
                          }),
                        ]
                      ),
                      _c(
                        "span",
                        { key: "pct-" + idx, staticClass: "country-pct" },
                        [_vm._v(_vm._s(item.pct) + "%")]
                      ),
                    ]
                  }),
                ],
                2
              ),
            ])
          : _vm._e(),
        _vm.topFunctions.length
          ? _c("div", { staticClass: "demo-block" }, [
              _c("div", { staticClass: "block-title" }, [
                _vm._v(
                  _vm._s(_vm.$t("dash.reporting.section.demographie.function"))
                ),
              ]),
              _c(
                "div",
                { staticClass: "country-list" },
                [
                  _vm._l(_vm.topFunctions, function (item, idx) {
                    return [
                      _c(
                        "span",
                        { key: "rank-" + idx, staticClass: "country-rank" },
                        [_vm._v(_vm._s(idx + 1))]
                      ),
                      _c(
                        "span",
                        { key: "name-" + idx, staticClass: "country-name" },
                        [_vm._v(_vm._s(item.name))]
                      ),
                      _c(
                        "div",
                        { key: "bar-" + idx, staticClass: "country-bar-wrap" },
                        [
                          _c("div", {
                            staticClass: "country-bar li-function-bar",
                            style: { width: item.barWidth + "%" },
                          }),
                        ]
                      ),
                      _c(
                        "span",
                        { key: "pct-" + idx, staticClass: "country-pct" },
                        [_vm._v(_vm._s(item.pct) + "%")]
                      ),
                    ]
                  }),
                ],
                2
              ),
            ])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "chip-icon age-icon" }, [
      _c(
        "i",
        {
          staticClass: "material-icons",
          staticStyle: { color: "#6B1F4D", "font-size": "20px" },
        },
        [_vm._v("cake")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }